<template>
    <!-- The Modal -->
    <b-modal
        id="vehicle-stock-rep-note-model"
        :title="getTitle()"
        v-model="modalOpen"
        no-fade
        size="lg"
        @change="onModalChange"
        @hide="onModalChange"
        @show="onModalChange">
        <template v-slot:modal-footer>
            <b-btn @click="modalOpen = false">Cancel</b-btn>
            <b-btn @click="saveNote()">Save</b-btn>
        </template>
        <div>
            <div class="form-group inline-label">
                <label for="vehicle-stock-rep-note">Message</label>
                <textarea ref="message" id="vehicle-stock-rep-note" v-model="note"></textarea>
            </div>
        </div>
    </b-modal>
</template>
<script>
export default {
    props: {
        vehicle : [Object],
        value : [String, Number, Boolean, Array],
    },
    data() {
        return {
            note: '',
            modalOpen: false,
        }
    },
    watch: {
        value(){
            this.modalOpen = !!this.value;
        }
    },
    methods: {
        onModalChange(){
            this.$emit('input', this.modalOpen);
            this.note = this.vehicle.rep_note
        },
        getTitle(){
            if (this.vehicle){
                return `Rep note for ${this.vehicle.year} ${this.vehicle.make} ${this.vehicle.model}`
            } else {
                return `Rep note`;
            }
        },
        saveNote(){
            this.$store.dispatch('vehicleStock/updateRepNote', {
                id: this.vehicle.id,
                data: {rep_note: this.note},
            }).then(res => {
                this.$notify({
                    title: 'Success',
                    message: res.message || 'Rep note saved.',
                    type: 'success'
                });
                this.$emit('vehicleUpdated');
                this.modalOpen = false;
            }).catch(err => {
                console.warn('err', err)
                this.modalOpen = false;
                this.$notify({
                    title: 'Error',
                    message: res.message || 'Failed to save rep note.',
                    type: 'error'
                });
            });
            return false;
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/VehicleStock/VehicleStockRepNote.vue